module.exports = __webpack_public_path__ + "img/oufu_42x66x8b.prt.e3aae0f0.jpg";